export const headerText = (value) => {
    return {
        type: value
    }
}